import api from "../api";

export const SET_FULL_RESTAURANT = "SET_FULL_RESTAURANT";
export const SET_CHAIN_REVIEWS = "SET_CHAIN_REVIEWS";
export const SET_CHAIN_REVIEWS_LOADING = "SET_CHAIN_REVIEWS_LOADING";

export const getFullRestaurant = async (dispatch, id) => {
  dispatch({
    type: SET_FULL_RESTAURANT,
    payload: {},
  });

  const response = await api.getFullRestaurant(id);

  response.reviews.sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  });

  dispatch({
    type: SET_FULL_RESTAURANT,
    payload: response,
  });
};

export const getChainReviews = async (dispatch, chainId, restaurantIdToExclude, allowCache = true) => {
  dispatch({
    type: SET_CHAIN_REVIEWS_LOADING,
    payload: true,
  });

  try {
    const response = await api.getChainReviews(chainId, restaurantIdToExclude, allowCache);

    if (response && response.reviews) {
      // Sort reviews by creation date
      response.reviews.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });

      dispatch({
        type: SET_CHAIN_REVIEWS,
        payload: response.reviews,
      });
    } else {
      clearChainReviews(dispatch);
    }
  } catch (error) {
    console.error("Failed to fetch chain reviews:", error);
    clearChainReviews(dispatch);
  }
};

export const clearChainReviews = (dispatch) => {
  dispatch({
    type: SET_CHAIN_REVIEWS,
    payload: [],
  });
};
